// src/PrivacyPolicy.js
import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>Welcome to the Privacy Policy of Fintexl. This policy outlines how we collect, use, and share the personal information you provide through our services.</p>

      <h2>1. Personal Information We Collect</h2>
      <p><strong>Information You Provide:</strong> We collect personal data you submit through forms, emails, chat, or registration, such as name, email, address, phone, etc.</p>
      <p><strong>Information from Third Parties:</strong> Includes sources like marketing partners, public databases, or social media platforms.</p>
      <p><strong>Automatic Information:</strong> Includes cookies, IP address, browser/device type, screen resolution, and usage data.</p>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To deliver services and respond to inquiries</li>
        <li>To send product updates and marketing materials</li>
        <li>To personalize user experiences and improve our offerings</li>
        <li>To comply with legal and regulatory obligations</li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>We may share information with service providers, legal authorities, or during business transactions. Anonymized data may be used for analytics.</p>

      <h2>4. Security of Information</h2>
      <p>We use encryption and access controls, but no system is 100% secure. Please use strong passwords and logout after use.</p>

      <h2>5. Children’s Data</h2>
      <p>We do not knowingly collect data from children under 18 without parental consent.</p>

      <h2>6. Third-Party Links</h2>
      <p>Our website may include links to third-party platforms. We are not responsible for their privacy practices.</p>

      <h2>7. Data Transfers and Retention</h2>
      <p>Your data may be processed in India. We retain it only as long as needed to comply with laws and ensure service continuity.</p>

      <h2>8. Changes to This Policy</h2>
      <p>This policy may change. We encourage users to review it regularly for updates.</p>

      <p>For questions, please contact us via our website.</p>
    </div>
  );
}

export default PrivacyPolicy;
